export default [
    {
        path: "accessibility-scans",
        meta: {
            title: "Accessibility Scans",
        },
        component: () =>
            import(
                /* webpackChunkName: "A11yScans" */ "@/views/A11yScans/Wrapper.vue"
            ),
        children: [
            {
                path: "",
                name: "a11y_scans_index",
                meta: {
                    title: "Accessibility scans",
                    pageContentHeaderComponent: () =>
                        import("@/views/A11yScans/CreateNewScanButton.vue"),
                },
                component: () =>
                    import(
                        /* webpackChunkName: "A11yScansList" */ "@/views/A11yScans/Index.vue"
                    ),
            },
        ],
    },
];
